import React from 'react';
import { Box, Typography, Card, CardContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ErrorIcon from '@material-ui/icons/Error';

const useStyles = makeStyles((theme) => ({
  errorCard: {
    backgroundColor: theme.palette.type === 'dark' ? '#2a1a1a' : '#fff5f5',
    border: `1px solid ${theme.palette.type === 'dark' ? '#d32f2f' : '#ffcdd2'}`,
    borderRadius: '8px',
    boxShadow: theme.palette.type === 'dark' 
      ? '0 4px 12px rgba(0,0,0,0.3)' 
      : '0 2px 8px rgba(0,0,0,0.1)',
  },
  errorIcon: {
    color: theme.palette.error.main,
    fontSize: '48px',
    marginBottom: theme.spacing(2),
  },
  errorTitle: {
    color: theme.palette.text.primary,
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  errorMessage: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
  errorDetails: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    opacity: 0.8,
  },
}));

interface ServiceUnavailableErrorProps {
  error?: string | null;
  showErrorDetails?: boolean;
}

export const ServiceUnavailableError: React.FC<ServiceUnavailableErrorProps> = ({
  error = null,
  showErrorDetails = false,
}) => {
  const classes = useStyles();

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px" p={3}>
      <Card className={classes.errorCard}>
        <CardContent>
          <Box display="flex" flexDirection="column" alignItems="center" textAlign="center" p={3}>
            <ErrorIcon className={classes.errorIcon} />
            <Typography variant="h5" className={classes.errorTitle}>
              DFP Service is not available
            </Typography>
            <Typography variant="body1" className={classes.errorMessage}>
              Sorry for the inconvenience! The DFP service is currently unavailable. Please try again later.
            </Typography>
            {showErrorDetails && error && (
              <Box mt={2} p={2} style={{ 
                backgroundColor: 'rgba(0,0,0,0.05)', 
                borderRadius: '4px',
                maxWidth: '500px',
                width: '100%'
              }}>
                <Typography variant="body2" className={classes.errorDetails}>
                  Error details: {error}
                </Typography>
              </Box>
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

